export function attachAccordionHandlers() {
  $('.ui-accordion-header').on('click', accordionToggle);
}

function accordionToggle() {
  $(this).closest('.ui-accordion').toggleClass('opened');
}